import { BrowserModule } from '@angular/platform-browser';
import { InjectionToken, NgModule } from '@angular/core';

import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';

export const REST_BASE_URL = new InjectionToken('REST_BASE_URL');
export const REST_ENDPOINTS = new InjectionToken('REST_ENDPOINTS');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [
    { provide: REST_BASE_URL, useValue: environment.restBaseUrl },
    { provide: REST_ENDPOINTS, useValue: environment.restEndpoints }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /builds/iws/vanenet/src/app/app.module.ts